import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconCloseSvg } from "./IconCloseSvg.mjs";
const IconClose = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconCloseSvg, ...iconProps });
};
export {
  IconClose
};
